// 마이크 이펙트
import { ref } from 'vue';


const minRadious = 0.5; // 최소 반지름
const maxRadious = 2; // 최대 반지름
const threshold = 20; // 데시벨 임계값
export const outerRadius = ref(minRadious); // 외부 반지름 값
export const isShowMicEffect = ref(false); // 마이크 이펙트 표시 여부

export const setupMicEffect = (audioContext, source) => {
  const analyser = audioContext.createAnalyser(); // 오디오 분석기 생성
  source.connect(analyser); // 소스를 분석기에 연결

  const bufferLength = analyser.frequencyBinCount; // 분석기 버퍼 크기
  const dataArray = new Uint8Array(bufferLength); // 주파수 데이터를 저장할 배열

  let r = outerRadius.value; // 현재 반지름 값

  const draw = () => {
    requestAnimationFrame(draw); // 다음 프레임을 요청

    analyser.getByteFrequencyData(dataArray); // 주파수 데이터를 가져옴

    const average = dataArray.reduce((a, b) => a + b) / bufferLength; // 주파수 데이터의 평균 계산

    if (average > threshold) {
      isShowMicEffect.value = true; // 데시벨이 임계값을 초과하면 마이크 이펙트를 표시
      r = average * 0.015; // 데시벨에 따라 반지름 크기 조절
      if (r > maxRadious) {
        r = maxRadious; // 최대 반지름 제한
      } else if (r < minRadious) {
        r = minRadious; // 최소 반지름 제한
      }
      outerRadius.value = r; // 외부 반지름 값 업데이트
    } else {
      isShowMicEffect.value = false; // 데시벨이 임계값 이하일 경우 마이크 이펙트를 숨김
    }
  };
  draw(); // 이펙트 시작
};
